import React from 'react';

import SVGIcon from '../../atoms/SVGIcon';
import { Button, SvgWrapper } from './styles';
import { NavButtonWithIconProps } from './interface';

const NavButtonWithIcon = (props: NavButtonWithIconProps) => {
  const { isSelected, icon, children, onClick, className } = props;
  return (
    <Button className={className} isSelected={isSelected} onClick={onClick}>
      <SvgWrapper>
        <SVGIcon icon={icon} size="40px" />
      </SvgWrapper>
      {children}
    </Button>
  );
};

export default NavButtonWithIcon;
